import { assert } from '@varos/util-typescript';
import { ReportingShellLoaderBaseConfig } from '../../../base';
import { ChatLayoutLoader } from './chatLayoutInterface';
import { ChatLayoutAggregate } from './chatLayoutModel';
import { useMemo } from 'react';

export function createChatLayoutLoader(
    config: ReportingShellLoaderBaseConfig
): ChatLayoutLoader {
    const {
        repository: { research, assistant },
    } = config;
    return {
        useLoad(context, props): ChatLayoutAggregate {
            const threadQuery = assistant.thread.useFind(
                context,
                {
                    limit: 10,
                },
                {
                    suspense: true,
                    select(data) {
                        return data.filter((thread) => thread.id === props.thread);
                    },
                }
            );
            assert(threadQuery.status === 'success', 'expected suspense');

            const thread = useMemo(() => {
                return threadQuery.data[0] ?? null;
            }, [threadQuery.data]);

            return {
                thread,
            };
        },
    };
}
